import { render, staticRenderFns } from "./weightHandling.vue?vue&type=template&id=68a64872&scoped=true&"
import script from "./weightHandling.vue?vue&type=script&lang=js&"
export * from "./weightHandling.vue?vue&type=script&lang=js&"
import style0 from "./weightHandling.vue?vue&type=style&index=0&id=68a64872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a64872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a64872')) {
      api.createRecord('68a64872', component.options)
    } else {
      api.reload('68a64872', component.options)
    }
    module.hot.accept("./weightHandling.vue?vue&type=template&id=68a64872&scoped=true&", function () {
      api.rerender('68a64872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FrontEndWarehouse/components/warehouseHome/weightHandling.vue"
export default component.exports